/**
 * Branding — the single source of truth for the product name.
 *
 * The product is **MiOS**. Every spelling that appears anywhere in
 * the frontend — login screen, AppShell badge, conversation labels,
 * dictionaries, HTML title — must come from this module.
 *
 * Override with the ``REACT_APP_APP_NAME`` env var at build time
 * for white-labelled deployments.
 */

export const APP_NAME = process.env.REACT_APP_APP_NAME || "MiOS";
export const APP_TAGLINE = "Cognitive Operating System";
export const APP_TITLE = `${APP_NAME} — ${APP_TAGLINE}`;
